import { slickDefaults } from '@/utils/carousel';

class HomeFeature {
    constructor() {
        this.$el = $('.home-feature');

        this.ui = {
            $items: $('.home-feature__container', this.$el),
        };

        this.featureToggle();
    }

    featureToggle() {
        this.ui.$items.each(function() {
            $(this).find('.home-feature__figure').mouseenter(function (){
                $(this).parents('.home-feature__container').addClass('home-feature__container_hide');
            });

            $(this).find('.home-feature__figure').mouseleave(function (){
                $(this).parents('.home-feature__container').removeClass('home-feature__container_hide');
            });
        })
    }
}

export default HomeFeature;
